<template>
  <v-card>
    <v-tabs :value="promoFactTab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchPromotionFactors()">Factors</v-tab>
      <v-tab v-show="displayFactReviewTab">Rates</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { PROMOTION_PROMOFACT_TABMENU } from '@/store/types'

export default {
  computed: {
    promoFactTab() {
      return this.$store.state.promotionManagement.promotion.promoFactorTabMenu
    },
    displayFactReviewTab() {
      return this.$store.state.promotionManagement.promotion.promoFactorDisplayFactReviewTab
    }
  },
  methods: {
    fetchPromotionFactors() {
      const commitData = {
        promoFactTab: 0,
        displayFactReviewTab: false,
        displayRateTab: false
      }
      this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
      this.$router.push({ name: 'promotionFactorsQuery', params: { promotion: this.promotion } })
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchPromotionFactors()
  }
}
</script>

<style lang="scss">
</style>
